import React from 'react';

import Seo from '../../components/Seo'
import { Box } from '@primer/components'

import Price from './Price'

export default function(props) {
  return (
    <Box className="position-relative">
      <Seo
        title={'Setup Code Review Doctor Bitbucket integration'} 
        description={`Merge fewer Python and Django bugs during Bitbucket pull request code review.`}
      />
      <Box style={{background: 'linear-gradient(to right, #363795, #005C97)'}} className="" id="price">
        <Price />
      </Box>
    </Box>
  );
}
